import { LocalityCommonDistrict, LocalityCommonRegion } from '@domain-group/fe-allhomes-library/lib/node';
export var localityAliases = [{
  name: 'Capital Region',
  slug: 'capital-region',
  newListingsSlug: 'canberra-act',
  localities: [LocalityCommonRegion.CANBERRA, LocalityCommonDistrict.GREATER_QUEANBEYAN, {
    id: 2072,
    slug: 'bungendore-braidwood-queanbeyan-region-nsw',
    type: 'DISTRICT'
  }, {
    id: 1517,
    slug: 'cooma-snowy-nsw',
    type: 'DISTRICT'
  }, {
    id: 2431,
    slug: 'yass-valley-southern-tablelands-nsw',
    type: 'DISTRICT'
  }],
  metaData: {
    state: 'ACT'
  },
  regionId: '391'
}, {
  name: 'Canberra & Queanbeyan',
  slug: 'canberra-queanbeyan',
  newListingsSlug: 'canberra-queanbeyan',
  localities: [LocalityCommonRegion.CANBERRA, LocalityCommonDistrict.GREATER_QUEANBEYAN],
  metaData: {
    state: 'ACT'
  },
  regionId: '391'
}];
export var CapitalRegion = localityAliases[0];
export var CanberraQueanbeyan = localityAliases[1];
export var findAlias = locality => localityAliases.find(alias => alias.newListingsSlug === locality.newListingsSlug || alias.slug === locality.slug);
export var aliasesForRegion = regionId => localityAliases.filter(alias => alias.regionId === regionId);